<template>
<div class="container-fluid">

<div class="card border-primary mb-3">
  <h4 class="card-header bg-primary text-white">REGISTRAZIONE GIFT CARD</h4>
  <div class="card-body">
<form v-on:submit.prevent="submit()">
  <div class="form-group row">    
    <label for="inputTotal" class="col-sm-2 col-form-label">IMPORTO</label>
    <div class="col-sm-10">
      <input autocomplete="off" required v-focus type="number" class="form-control" id="inputTotal" v-model="GiftCard.gc_amount">
    </div>
  </div>  
  <div class="form-group row">
    <label for="inputEmail3" class="col-sm-2 col-form-label">EMAIL</label>
    <div class="col-sm-10">
      <input autocomplete="off" required type="email" class="form-control" id="inputEmail3" v-model="GiftCard.email">
    </div>
  </div>
  <div class="form-group row">    
    <label for="inputLastName" class="col-sm-2 col-form-label">COGNOME</label>
    <div class="col-sm-10">
      <input autocomplete="off" required type="text" class="form-control" id="inputLastName" v-model="GiftCard.last_name">
    </div>
  </div>
  <div class="form-group row">
    <label for="inputFirstName" class="col-sm-2 col-form-label">NOME</label>
    <div class="col-sm-10">
      <input autocomplete="off" required type="text" class="form-control" id="inputFirstName" v-model="GiftCard.first_name">
    </div>
  </div>

  
  <div class="form-group row">
    <div class="col-sm-10">
      <button :disabled="spinner1" type="submit" class="btn btn-primary">
        <span v-if="spinner1" class="spinner-border spinner-border-sm mr-3" role="status" aria-hidden="true"></span>
        REGISTRA</button>
    </div>
  </div>
  
  

</form>
  
 <div v-if="GiftCard.gc_code" class="alert alert-success border border-success" role="alert">
    <h4 class="alert-heading">GIFT CARD CREATA</h4>
    <p>CON IL CODICE <strong> {{ GiftCard.gc_code }}</strong></p>
    <button :disabled="spinner2" class="btn btn-outline-success" @click="printXML(GiftCard.gc_code)">
       <span v-if="spinner2" class="spinner-border spinner-border-sm mr-3" role="status" aria-hidden="true"></span>
      STAMPA BARCODE
    </button>        
 </div>


<div v-if="alert_msg" class="alert alert-danger" role="alert">
  {{ alert_msg }}
</div>

  </div>
</div>




</div>
</template>
<script>
import api                 from '@/api'
//import IP                  from '@/components/mixins/PrinterIP.js'
import { mapGetters }      from 'vuex';
export default {
  
 // mixins : [IP],
  data () {
    return {

     
      GiftCard   : {}, 
      alert_msg  : '',
      spinner1   : false,
      spinner2   : false,
      printerIP  : '',
      
      url        : 'https://kfercjn6z0.execute-api.eu-central-1.amazonaws.com/prod/create'
      
    }
  },
    directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
  computed: 
  {
    ...mapGetters(['company','storeId']) ,   
  },
  async mounted()
    {
    
      const printerIP = JSON.parse(localStorage.getItem("printerIP"))
      //const IP = await this.getPrinterIP(this.storeId)
      if(printerIP)
      {
        this.printerIP = printerIP
      }
      
      
      
    },
  methods: 
    {
    
    
     printXML(code) {
      // XML da inviare
      this.spinner2 = true
      this.alert_msg = ''
    
      let param = '<parameter xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">';
          param += '<devid>local_printer</devid>';
          param += '<timeout>10000</timeout>';
          param += '</parameter>';

      let xmlData = `<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">` 
          xmlData += '<text align="center"/>' 
          xmlData +=  `<barcode font="font_a" height="120"  width="1" hri="above" type="code128">{B` + code + `</barcode>`
          xmlData += `<feed line="5"/> <cut type="feed"/></epos-print>`;

      const soap = '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
        '<s:Header>' + param + '</s:Header><s:Body>' + xmlData +
          '</s:Body></s:Envelope>';

      // Imposta l'indirizzo della stampante
      const printerIP = this.printerIP + "/cgi-bin/epos/service.cgi?devid=local_printer&timeout=10000"
      
      fetch(printerIP, {
        method  : "POST",
        headers : 
        {
          "Content-Type": "text/xml"
        },
        body    : soap
      })
      /*.then(response => response.text())*/
      .then(result => {
        this.spinner2 = false
        console.log("Risposta dalla stampante:\n", result);
        //alert("Stampa inviata con successo.");
      })
      .catch(error => 
      {
        this.spinner2 = false
        console.error("Errore:", error);
        this.alert_msg =  "Errore durante la stampa. " +  error
        //alert("Errore durante la stampa.");
      });
    },



    async submit()
    {

      this.GiftCard.gc_code = ''
      
      const url             =  this.url
      
      const data            = this.GiftCard
      const json            = data
      this.spinner1         = true
      this.alert_msg        = ''
      this.GiftCard.gc_code = ''
      await api.caposerio(json,url).then(res => {
          if(res.status==200)
            {   
                const data    = res.data.body

                this.spinner1 = false
                this.GiftCard = {}
                this.GiftCard.gc_code = data.gc_code
            }
        
        console.log(res)
      }).catch(err => {
            this.spinner1 = false
            console.log(err)  
            this.alert_msg = err  
          })

      
    }
    
    
    }
  
  
  }

</script>

<style scoped>


</style>

